import { useMutation, useQuery } from 'react-query';
import amazonAccountServices from './amazonAccount.services';
import notificationError from '@/utils/functions/notificationError';
import { Modal, notification } from 'antd';
import { queryClient } from '@/Root';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';
import { AxiosError } from 'axios';

export function useAmazonAccountGet() {
  const cache = queryClient.getQueryData(['amazon/linking']);

  return useQuery(['amazon/linking'], amazonAccountServices.get, {
    enabled: !cache,
    onError(err: AxiosError) {
      if (err.response?.status !== 404) {
        notificationError(err);
      }
    },
  });
}

export function useAmazonAccountPost() {
  const queryChanel = useQueryChanel();

  return useMutation(amazonAccountServices.post, {
    onSuccess() {
      notification.success({ message: 'Conta da Amazon vinculada' });

      Modal.success({
        width: 600,
        title: 'Conta vinculada!',
        icon: <span style={{ fontSize: 42 }}>🎉</span>,
        content: (
          <>
            <p>
              Sua conta da Amazon foi vinculada com sucesso. Agora você tem
              acesso a nossa nova funcionalidade de integração com a Alexa.
            </p>
            <p>
              Abra o aplicativo da Alexa e instale a habilidade da Ultracar e
              tenha acesso a comandos para automatizar o dia-a-dia da sua
              oficina
              <br />
              <a
                href="https://www.amazon.com.br/dp/B0DBL8QQR6/"
                target="_blank"
                style={{ fontWeight: 500 }}
              >
                Ou clique aqui para acessar a página da Skill.
              </a>
            </p>

            <p>
              Depois vá ao instagram da Ultracar e nos conte o que achou da
              novidade!
            </p>
          </>
        ),
        okText: 'Fechar',
      });

      queryChanel({ invalidateQueries: [['amazon/linking']] });
    },

    onError(err) {
      notificationError(err);
    },
  });
}

export function useAmazonAccountRemove() {
  const queryChanel = useQueryChanel();

  return useMutation(amazonAccountServices.remove, {
    onSuccess() {
      notification.success({ message: 'Conta da Amazon desvinculada' });

      queryChanel({ removeQueries: [['amazon/linking']] });
    },

    onError(err) {
      notificationError(err);
    },
  });
}
